var CookieConsent = (function() {

  function handleCookieBox() {
    expiredays = $cookieBox.attr("data-cookie-expires-days");
    setCookie("am_cookieboxclosed", "true", expiredays);
    $cookieBox.addClass("cookiebox--hide");
    $(window).off("beforeunload");
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function init() {

    $cookieBox = $(".cookiebox");
    $closeBtn = $cookieBox.find(".cookiebox__button--close");

    if (getCookie("am_cookieboxclosed") == "") {
      $cookieBox.removeClass("cookiebox--hide");

      $(window).on("beforeunload", function() {
        handleCookieBox();
      });
      $closeBtn.on("click", handleCookieBox);
      $closeBtn.on("keydown", function(e) {
        if (e.which == "13") {
          handleCookieBox();
        }
      });
    }
  }


  var $cookieBox, $closeBtn, expiredays;

  return {
    init: init
  };

})();

export { CookieConsent };